import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { CompetencyModel } from '@/models/drill-down/competency';
import { numberFormat } from '@/helpers/number-format';

import { getNetworkDefaultURL } from '@/utils/utils';
import { ClassCompetencyData } from '@/models/groups/class';
import { ReportData } from '@/models/groups/report';
import { appConfigService } from '@/providers/services/app/app-config';
import { CLASS_SORT_TYPES, DEMO_HIERARCHY_HEADS, GUEST_USER_DRILL_DOWN_IDS } from '@/utils/constants';
import ClassProgressReport from '@/components/cards/class-progress-report/class-progress-report';
import ClassLevel from '@/components/cards/class-level-card/class-level-card';
import { classAPI } from '@/providers/apis/class/class';

@Component({
    name: 'drilldown-list',
    components: {
        'material-icon': GoogleMaterialIcon,
        'class-report': ClassProgressReport,
        'class-level': ClassLevel,
    },
})

export default class DrilldownList extends Vue {

    // ---------------------------------------------------------------
    // Properties
    @Prop()
    private competencyData?: ReportData;
    @Prop()
    private classCompetencyData?: ClassCompetencyData;
    @Prop()
    private groupType!: string;
    @Prop()
    private groupName!: string;
    @Prop()
    private activeMonth!: string;
    @Prop()
    private activeYear!: string;

    @Prop({ default: false })
    private isRestrictClass!: boolean;

    @Prop()
    private activeSubject: any;

    private hiddenData: boolean = false;

    private drilldownSearchTerm: string = '';

    private filteredItems: any[] = [];

    private urldata: any;

    private instructionalClassIds: any = [];

    private instructorText: string = this.$access.isDemoGroup ? 'Instructor' : 'Teacher';

    get groupLabel() {
        const accessibleLevels = appConfigService.getUserGroupAccessLevel();
        const activeLevelIndex = accessibleLevels.findIndex((level: any) => level.type === this.groupType);
        if (this.$access.isDemoGroup) {
            return DEMO_HIERARCHY_HEADS[this.groupType] || this.groupType;
        }
        return activeLevelIndex >= 0 ? accessibleLevels[activeLevelIndex + 1] ?
            accessibleLevels[activeLevelIndex + 1].name
            : (this.groupType === 'class' ? 'Student' : this.groupType) : this.groupType;
    }

    private get drilldownList() {
        let drilldownList: any = [];
        if (this.groupType === 'class') {
            drilldownList = this.classCompetencyData && this.classCompetencyData.drilldown ?
                this.sortArray('masteredCompetencies', this.classCompetencyData.drilldown
                    ? JSON.parse(JSON.stringify(this.classCompetencyData.drilldown)) : []) :
                [];
        } else if (this.groupType === 'school') {
            drilldownList = this.competencyData && this.competencyData.drilldown ?
                this.sortArray(this.activeSortType.key, JSON.parse(JSON.stringify(this.competencyData.drilldown))) :
                [];
        } else {
            drilldownList = this.competencyData && this.competencyData.drilldown ?
                this.sortArray('masteredCompetencies', JSON.parse(JSON.stringify(this.competencyData.drilldown))) :
                [];
        }

        this.filteredItems = drilldownList.reverse();
        if (this.groupType === 'school') {
            this.filteredItems = this.sortingOrder ? drilldownList.reverse() : drilldownList;
        }
        return drilldownList;
    }

    private get isGuestUser() {
        return this.$access.isGuestUser('guest', 'guest');
    }

    private get hasProgressReport() {
        return this.groupType === 'school';
    }

    private guestIds: any = GUEST_USER_DRILL_DOWN_IDS;

    private sortDropdownList: Array<{ name: string, key: string }> = CLASS_SORT_TYPES;

    private activeSortType: { name: string, key: string } = CLASS_SORT_TYPES[0];

    private sortingOrder: boolean = true;

    private classReportLevel: any = null;

    private showClassProgress: boolean = false;

    private classLevel: any = null;

    private showClassLevel: boolean = false;

    // -------------------------------------------------------------
    // Hooks

    private created() {
        if (this.activeSortType && this.$access.isDemoGroup) {
            this.activeSortType.name = 'By Instructor';
        }
    }


    // ---------------------------------------------------------------
    // Actions
    private onSelectLevel(seletectLevel: any) {
        if (this.isGuestUser && this.guestIds[seletectLevel.type]
            && this.guestIds[seletectLevel.type] !== seletectLevel.id) {
            return;
        }
        if (seletectLevel.type === 'student') {
            if (this.$access.hasPermission(this.$access.menus.learners, this.$access.ACL.learnerIdentity)) {
                this.$router.push(`/learners/${seletectLevel.id}?activeYear=${this.activeYear}&activeMonth=${this.activeMonth}`);
            }
        } else {
            this.$emit('onSelectLevel', seletectLevel, this.activeSubject);
        }
    }

    private onSearchItems() {
        this.filteredItems = this.drilldownList.filter((drilldown: any) => {
            if (this.groupType === 'school' && this.activeSortType.key === 'last_name') {
                return drilldown.last_name.toLowerCase().includes(this.drilldownSearchTerm.toLowerCase())
                    || drilldown.first_name.toLowerCase().includes(this.drilldownSearchTerm.toLowerCase());
            }
            return drilldown.name.toLowerCase().includes(this.drilldownSearchTerm.toLowerCase());
        });
    }

    private onClearSearch() {
        this.drilldownSearchTerm = '';
        this.filteredItems = this.drilldownList;
    }

    private onSelectSort(sort: { name: string, key: string }) {
        this.sortingOrder = true;
        if (sort.key === 'masteredCompetencies') {
            this.sortingOrder = false;
        }
        this.activeSortType = sort;
    }

    private onShowClassProgress(drilldown: any) {
        this.showClassProgress = true;
        this.classReportLevel = drilldown;
    }

    private onShowClassLevel(drilldown: any) {
        this.showClassLevel = true;
        this.classLevel = drilldown;
    }

    // -------------------------------------------------------------
    // Methods
    private numberFormat(value: number) {
        return numberFormat(value);
    }

    private sortArray(key: string = 'fullName', list: any[] = []) {
        return list.sort((a: any, b: any) => {
            if (a[key] < b[key]) { return -1; }
            if (a[key] > b[key]) { return 1; }
            return 0;
        });
    }

}
